import type { EmployeeRole, EmployeeStatus } from "@/types";

export const EMPLOYEE_ROLE_CONFIG: Record<
  EmployeeRole,
  { label: string; description: string; icon: string; className: string }
> = {
  cashier: {
    label: "كاشير (أمين صندوق)",
    description: "استقبال العملاء، وإتمام عمليات البيع، وإصدار الفواتير.",
    icon: "ri-user-line",
    className: "bg-secondary-200 text-secondary-900",
  },
  shiftSupervisor: {
    label: "مشرف شفت (فترة)",
    description:
      "متابعة العمل خلال فترة التشغيل والإشراف على تنفيذ المهام اليومية.",
    icon: "ri-time-line",
    className: "bg-accent-100 text-accent-800",
  },
  operationsOfficer: {
    label: "مسؤول عمليات",
    description: "متابعة تقارير المبيعات.",
    icon: "ri-line-chart-line",
    className: "bg-secondary-100 text-secondary-900",
  },
  branchManager: {
    label: "مدير فرع",
    description: "الإشراف على تشغيل الفرع وإدارة فريق العمل والمهام اليومية.",
    icon: "ri-user-star-line",
    className: "bg-primary-100 text-primary-800",
  },
  generalSupervisor: {
    label: "مشرف عام / مالك فروع",
    description: "متابعة مجموعة الفروع والإشراف على الأداء العام.",
    icon: "ri-vip-crown-line",
    className: "bg-accent-200 text-accent-900",
  },
};

export const EMPLOYEE_STATUS_CONFIG: Record<
  EmployeeStatus,
  { label: string; className: string; dot: string }
> = {
  active: {
    label: "نشط",
    className: "bg-primary-100 text-primary-800",
    dot: "bg-primary-500",
  },
  suspended: {
    label: "موقوف",
    className: "bg-red-100 text-red-700",
    dot: "bg-red-500",
  },
};

export const EMPLOYEE_ROLE_OPTIONS: EmployeeRole[] = [
  "cashier",
  "shiftSupervisor",
  "operationsOfficer",
  "branchManager",
  "generalSupervisor",
];

export const EMPLOYEE_STATUS_OPTIONS: EmployeeStatus[] = [
  "active",
  "suspended",
];

export const normalizeSaudiPhone = (value: string): string =>
  value.replace(/[\s-]/g, "").replace(/^\+/, "");

export const isValidSaudiPhone = (value: string): boolean =>
  /^(05\d{8}|9665\d{8})$/.test(normalizeSaudiPhone(value));